import { createFileRoute } from "@tanstack/react-router";

import SecurityPage from "@/features/dashboard/pages/profile/pages/security";

export const Route = createFileRoute("/(app)/dashboard/settings/security")({
  component: () => <SecurityPage />,
});
